export default "__VITE_ASSET__CKPGh5no__"